import { c as _c } from "react/compiler-runtime";
import { Link, Spinner, TextBody } from "@opensea/ui-kit";
import { Check } from "@opensea/ui-kit/icons";
import { useEffect, useState } from "react";
import { useTranslations } from "use-intl";
import { CountDown } from "../CountDown";
export const ResendCode = t0 => {
  const $ = _c(32);
  const {
    codeExpiration,
    sendCode,
    setCodeExpired: setCodeExpiredProp
  } = t0;
  const t = useTranslations("wallet.ResendCode");
  const [codeExpired, setCodeExpiredState] = useState(false);
  let t1;
  if ($[0] !== setCodeExpiredProp) {
    t1 = expired => {
      setCodeExpiredState(expired);
      setCodeExpiredProp?.(expired);
    };
    $[0] = setCodeExpiredProp;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const setCodeExpired = t1;
  const [codeResendState, setCodeResendState] = useState("ready");
  let t2;
  if ($[2] !== sendCode || $[3] !== setCodeExpired) {
    t2 = async () => {
      setCodeResendState("resending");
      await sendCode();
      setCodeExpired(false);
      setCodeResendState("resent");
    };
    $[2] = sendCode;
    $[3] = setCodeExpired;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const resendCode = t2;
  let t3;
  let t4;
  if ($[5] !== codeResendState) {
    t3 = () => {
      if (codeResendState === "resent") {
        const timeout = setTimeout(() => {
          setCodeResendState("ready");
        }, 5000);
        return () => clearTimeout(timeout);
      }
    };
    t4 = [codeResendState];
    $[5] = codeResendState;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  useEffect(t3, t4);
  if (codeExpired) {
    let t5;
    if ($[8] !== t) {
      t5 = t("codeExpired");
      $[8] = t;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    let t6;
    if ($[10] !== codeResendState || $[11] !== resendCode || $[12] !== t) {
      t6 = codeResendState === "resending" ? <Link disabled={true}>{t("resendCode")}<Spinner className="absolute top-1 ml-1 size-2.5" color="blue-3" size="xs" /></Link> : <Link onClick={resendCode}>{t("resendCode")}</Link>;
      $[10] = codeResendState;
      $[11] = resendCode;
      $[12] = t;
      $[13] = t6;
    } else {
      t6 = $[13];
    }
    let t7;
    if ($[14] !== t5 || $[15] !== t6) {
      t7 = <TextBody asChild={true} className="mt-4" color="error-1" size="xs"><p className="relative">{t5}{" "}{t6}</p></TextBody>;
      $[14] = t5;
      $[15] = t6;
      $[16] = t7;
    } else {
      t7 = $[16];
    }
    return t7;
  }
  let t5;
  if ($[17] !== t) {
    t5 = t("expiresIn");
    $[17] = t;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== setCodeExpired) {
    t6 = () => setCodeExpired(true);
    $[19] = setCodeExpired;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== codeExpiration || $[22] !== t6) {
    t7 = <CountDown endTime={codeExpiration} onEnded={t6} />;
    $[21] = codeExpiration;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== codeResendState || $[25] !== resendCode || $[26] !== t) {
    t8 = codeResendState === "resending" ? <Link disabled={true}>{t("resendCode")}<Spinner className="absolute top-1 ml-1 size-2.5" color="blue-3" size="xs" /></Link> : codeResendState === "resent" ? <TextBody className="cursor-default" color="blue-3" size="xs">{t("codeResent")}<Check className="absolute top-0.5 ml-0.5 inline" size={14} /></TextBody> : <Link onClick={resendCode}>{t("resendCode")}</Link>;
    $[24] = codeResendState;
    $[25] = resendCode;
    $[26] = t;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  let t9;
  if ($[28] !== t5 || $[29] !== t7 || $[30] !== t8) {
    t9 = <TextBody asChild={true} className="mt-4" color="text-secondary" size="xs"><p className="relative">{t5}{" "}{t7}.{" "}{t8}</p></TextBody>;
    $[28] = t5;
    $[29] = t7;
    $[30] = t8;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  return t9;
};